module.exports = __webpack_public_path__ + "static/media/zolePlayed_5000_10000.dc677204.png";